import { OrderAscendingIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/inventory-management',
    component: () => import('@/layouts/index.vue'),
    name: 'inventoryManagement',
    redirect: '/inventory-management/inventory-list',
    meta: {
      title: '库存管理',
      icon: shallowRef(OrderAscendingIcon),
      orderNo: 0,
      permission: ['GetInventoryList'],
    },
    children: [
      {
        path: 'inventory-list',
        name: 'inventoryList',
        component: () => import('@/pages/inventory-management/inventory-list.vue'),
        meta: {
          title: '库存列表',
          permission: ['GetInventoryList'],
        },
      },
      {
        path: 'z-inventory-list',
        name: 'zInventoryList',
        component: () => import('@/pages/inventory-management/inventory-list.vue'),
        props: {
          inventoryCategory: 'Z',
        },
        meta: {
          title: 'Z库存列表',
          permission: ['GetInventoryList'],
        },
      },
    ],
  },
] as RouteRecordRaw[];
